import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from './helpers';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent font-medium bg-gray-50 hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        warning:
          'text-secondary-1000 bg-secondary-100 font-medium border-none rounded-3xl',
        success:
          'text-green-500 bg-green-100 font-medium border-none rounded-3xl',
        danger: 'text-red-500 bg-red-100 font-medium border-none rounded-3xl',
        customizable:
          'bg-gray-800 text-xs font-light rounded-3xl border-none py-2',
        primaryBlue:
          'text-blue-500 bg-blue-50 font-medium border-none rounded-2xl',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, className }))}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
